export default "__VITE_ASSET__CbJ2_xwi__"